import styled, { css } from 'styled-components'
import { Button as BPButton } from '@blueprintjs/core'

export const Button = styled(BPButton)`
  && {
    box-shadow: initial;
    display: inline-block;
    vertical-align: top;
    position: relative;
    margin: 0;
    /* height: 36px; */
    line-height: 34px;
    padding: 0 20px;
    box-sizing: border-box;
    /* style */
    font-size: 16px;
    text-align: center;
    font-weight: 400;
    font-family: 'Noto Sans TC', Helvetica, Arial, 'Helvetica Neue',
      '微軟正黑體', 'Microsoft JhengHei', PMingLiU, sans-serif;
    letter-spacing: 0.8px;
    /*text-transform: uppercase;*/
    text-decoration: none;
    color: ${props => (props.intent ? '#ffffff' : '#2D2D2D')};
    background-color: #d9d9d9;
    border: 0;
    outline: none;
    border-radius: 4px;
    /* interact */
    cursor: pointer;
    overflow: hidden;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
    transition: all 0.15s ease;

    /* intent */
    ${props =>
    props.intent === 'primary' &&
      css`
        background-color: #ff730e;
        /* border: 1px solid #ff730e; */
        :hover {
          background-color: #ff8e1e;
        }
        :active {
          background-color: #f68000;
        }
        /* line */
        ${props =>
    props.line &&
          css`
            border: 1px solid #ff730e;
            background-color: inherit;
            color: #ff730e;
            :hover {
              color: white;
              border: 1px solid #ff8e1e;
            }
          `};
      `};
     ${props =>
    props.intent === 'positive' &&
       css`
         color: #ffffff;
         border: 1px solid #9b9b9b;
         background-color: #9b9b9b;
         /* line */
         ${props =>
    props.line &&
           css`
             border: 1px solid #9b9b9b;
             background-color: inherit;
             color: #9b9b9b;
           `};
       `};

    /* disabled */
  ${props =>
    props.disabled &&
    css`
      && {
        color: #fff;
        pointer-events: none;
        background-color: #ececec;
        border: 1px solid #ececec;

        &:hover {
          border: 0;
        }
      }
    `}

  /* size */
  ${props =>
    props.large &&
    css`
      font-size: 16px;
      line-height: 40px;
      height: 44px;
      font-weight: 400;
    `}
  ${props =>
    props.small &&
    css`
      font-size: 16px;
      line-height: 32px;
      height: 36px;
    `}
  ${props =>
    props.minimal &&
    css`
      font-size: 13px;
      line-height: 32px;
      height: 32px;
      padding: 0 16px;
    `}

  /* rounded */
  ${props =>
    props.rounded &&
    css`
      height: 32px;
      line-height: 32px;
      border-radius: 16px;
      min-width: 88px;
    `}

  /* shadowed */
  ${props =>
    props.shadowed &&
    css`
      box-shadow: 0 20px 20px 0 rgba(0, 0, 0, 0.1);
    `}
  }
`

export const StyledFBLoginButton = styled(Button)`
  && {
    background-color: #3b5998;
    background-image: initial;
    border: 1px solid #3b5998;
    color: #fff;
    :before {
      content: '';
      display: inline-block;
      vertical-align: middle;
      background-image: url('/static/img/common/icon/social/facebook-w.svg');
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      width: 18px;
      height: 18px;
      margin-right: 8px;
      margin-top: -6px;
    }
    :hover {
      color: #fff;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Button/Button.styled.js